export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8272.2153a406.jpg";